import React, { useEffect } from "react";
import { Button, Stack } from "@mui/material";
import GroupIcon from "@mui/icons-material/Group";
import styled from "styled-components";
import Link from "@mui/material/Link";
import request from "src/utils/request";
import { useNavigate } from "react-router-dom";
import { useAuth } from "../../components/providers/auth-context";

const H = styled.h1`
    font-size: 20px;
    color: ${({ theme }) => theme.palette.primary.main};
`;

const P = styled.p`
    font-size: 12px;
    max-width: 400px;
    text-align: center;
`;

const Roadblock = () => {
    const { idToken } = useAuth();
    const navigate = useNavigate();

    useEffect(() => {
        if (!idToken || !idToken.mergedIdentity || idToken.loginMethodVerified)
            navigate("/dashboard");
    }, [idToken]);

    return (
        <Stack direction="column" alignItems="center">
            <GroupIcon color="primary" style={{ fontSize: "100px" }} />
            <H>Account already exists!</H>
            <P>
                We have detected a duplicate account using the same email address and your accounts
                have been merged.
            </P>
            <P>
                For security reasons, please validate your current email account using the link sent
                to your email.
            </P>

            <P>
                If you have not received an email.{" "}
                <Button
                    as={Link}
                    style={{
                        textTransform: "unset",
                        verticalAlign: "baseline",
                    }}
                    underline="hover"
                    onClick={() =>
                        request("/api/users/me/merged-identity-verification-email", {
                            method: "POST",
                        })
                    }
                >
                    click here to resend
                </Button>
            </P>
            <P>
                For any questions regarding this process.{" "}
                <Link underline="hover" href="mailto:info@adadot.com">
                    Contact us
                </Link>
            </P>
        </Stack>
    );
};

export default Roadblock;
